import { createSelector } from '@reduxjs/toolkit';
import GoalType from 'src/models/GoalType';
import { RootState } from "src/store";


const selectDailiesState = (state: RootState) => state.dailies;

export const selectDailyGoals = createSelector(
  [selectDailiesState],
  (dailies) => dailies.goals.filter((goal) => goal.type === GoalType.DailyBased)
);


export const selectDailyGoalsByTitle = createSelector(
  [selectDailiesState, (state: RootState, goalName: string) => goalName],
  (dailies, goalName) => {
    console.log("getting dailies with name "+ goalName);
    if(goalName == null)return [];
    return dailies.goals.find((goal) => goal.title.toUpperCase() === goalName.toUpperCase());
  }
);